import { Permiso } from '../../../../../../_entities/Enums/permiso.enum';
import { HistoricoPosicionesVehiculoComponent } from '../../../popups/vehiculos/historico-posiciones-vehiculo/historico-posiciones-vehiculo.component';
import { MapaService } from '../../../../services/mapa.service';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { VehiculosService } from '../../../../services/vehiculos.service';
import { Autos } from '../../../../../../_entities/autos/Autos';
import { DxDataGridComponent } from 'devextreme-angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AuthService } from './../../../../../../views/auth/auth.service';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'kt-vehiculo-modal',
	templateUrl: './vehiculo-modal.component.html',
	styleUrls: ['./vehiculo-modal.component.scss']
})
export class VehiculoModalComponent implements OnInit {
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
	// orders: Order[];
	public applyFilterTypes: any;
	public datosReporte = [];
	 isDisabled: boolean = true;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public usuario;
	public vehiculos: Autos[];
	public permisoVisualizarVehiculos: string;
	public mensajeAgrupar: string = "Para agrupar columnas, arrastre un encabezado aquí";
	private HWUser;
	private HWAutos;
	loadingVisible


	constructor(private vehiculosService: VehiculosService,
		private authService: AuthService,
		private dialogRef: MatDialogRef<VehiculoModalComponent>,
		private dialog: MatDialog,
		private datepipe: DatePipe,
		private mapaService: MapaService) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.HWUser = this.authService.getHWUser();
		this.obtenerPermisosVehiculos();
		this.obtenerHWAutos();
		//this.getVehiculos();
	}

	public get Permiso() {
		return Permiso;
	}
	private static getOrderDay(rowData) {
		return (new Date(rowData.OrderDate)).getDay();
	}

	calculateFilterExpression(value, selectedFilterOperations, target) {
		let column = this as any;
		if (target === "headerFilter" && value === "weekends") {
			return [[VehiculoModalComponent.getOrderDay, "=", 0], "or", [VehiculoModalComponent.getOrderDay, "=", 6]];
		}
		return column.defaultCalculateFilterExpression.apply(this, arguments);
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	clearFilter() {
		this.dataGrid.instance.clearFilter();
	}

	getVehiculos() {
		/*let token = '';
		if(this.HWUser) {
			token = this.HWUser.token;
		}*/

		this.loadingVisible = true;
		this.vehiculosService.obtenerAutos().pipe(
			finalize(
				() => {
					this.loadingVisible = false;
				}
			)
		).subscribe((vehiculos: Autos[]) => {
			this.vehiculos = vehiculos;
			this.vehiculos.forEach(vehiculo => {
				this.datosReporte.push({
					'IMEI': vehiculo.imeiFk.toString(),
					'Placas': vehiculo.placas,
					'Económico': vehiculo.economico,
					'Numero de Serie': vehiculo.numeroSerie,
					'Color': vehiculo.color,
					'Descripción': vehiculo.descripcion,
					'Modelo': vehiculo.modelo,
					'Año': vehiculo.anio
				});
			});
			if(this.datosReporte.length > 0){
				this.isDisabled = false;
			}
			//this.pintarMarcadoresAutos(vehiculos);
		})
	}

	/*public pintarMarcadoresAutos(autos: Autos[]) {
		/*if(this.HWAutos.data != null) {
			autos.forEach(auto => {
				let value = this.HWAutos.data.dataList.filter(function (data) { return data.deviceguid === auto.imeiFk.toString() })
				if (value.length) {
					let autoHW = value[0];

					let ignicion = 0;
					let estado = 0
					if (Number(autoHW.speed) > 5) {
						ignicion = 1;
						estado = 1;
					}

					auto.id = Number(autoHW.deviceguid)
					auto.lat = Number(autoHW.latitude);
					auto.lng = Number(autoHW.longitude);
					auto.estado = estado;
					auto.ignicion = ignicion;
					auto.velocidad = Number(autoHW.speed);
					auto.fechaHoraUltimaPosicion = autoHW.dtu
				}
			});

			this.vehiculos = autos;
		} else {
			this.vehiculos = autos;

		}*
		if (this.HWAutos) {
			autos.forEach(auto => {
				let value = this.HWAutos.filter(function (data) { return data.id === auto.imeiFk.toString() })
				if (value.length) {
					let autoHW = value[0];

					let ignicion = 0;
					let estado = 0
					if (Number(autoHW.ignicion) > 5) {
						ignicion = 1;
						estado = 1;
					}

					auto.id = Number(autoHW.id)
					auto.lat = Number(autoHW.lat);
					auto.lng = Number(autoHW.lng);
					auto.estado = estado;
					auto.ignicion = ignicion;
					auto.velocidad = Number(autoHW.velocidad);
					auto.fechaHoraUltimaPosicion = autoHW.fechaHoraUltimaPosicion
				}

			});
			//this.mapaService.registroVehiculos = autos;

			this.vehiculos = autos;

		} else {
			this.vehiculos = autos;

		}



	}*/

	obtenerHWAutos() {
		this.vehiculosService.obtenerUltimaPosicionAutosCamara('-1', -1,).subscribe(
			(response: any) => {
				//this.HWAutos = response
				this.getVehiculos();
			}, (error) => {
				this.getVehiculos()
				//console.log('error::::: ', error);
			}
		)
	}


	reportePosiciones(data: any) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "58%";
		dialogConfig.data = data;
		this.dialogRef.close();
		this.dialog.open(HistoricoPosicionesVehiculoComponent, dialogConfig);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	ubicarPuntoHistorico(data) {
		this.mapaService.verVehiculo(data);
		this.cerrarPopup();
	}

	/**Obtener permisos vehiculos */
	obtenerPermisosVehiculos() {
		this.permisoVisualizarVehiculos = Permiso.VisualizarVehiculos;
	}

}
